var React = require('react');

function MudraAnjali (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M36,33c0,0-8.658,0-9,0c-3.375,0-8-2.083-8-7\r\n\tc0,0,0-15.893,0-18.998c0-1.104,0.896-2,2-2S23,5.5,23,5.5V17 M19,7.002c0,0,0-2.896,0-4s0.896-2,2-2S23,1.5,23,1.5V10\r\n\tc0,0,2.198,7.462,3.688,11.87C26.884,22.449,27.25,23,28,23s8,0,8,0 M2,33c0,0,8.658,0,9,0c3.375,0,8-2.083,8-7\r\n\tc0,0,0-15.893,0-18.998c0-1.104-0.896-2-2-2S15,5.5,15,5.5V17 M2,23c0,0,7.25,0,8,0s1.116-0.551,1.312-1.13\r\n\tC12.802,17.462,15,10,15,10V1.5c0,0,0.896-0.498,2-0.498s2,0.896,2,2s0,4,0,4"}));
}

MudraAnjali.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = MudraAnjali;

MudraAnjali.default = MudraAnjali;
